// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Hlfy","delete":"styles_delete__1GT2E","update":"styles_update__3cP9C","add":"styles_add__3l7a-"};